// extracted by mini-css-extract-plugin
export default {"asset":"asset_asset__lkI9-","oneInRow":"asset_oneInRow__j9HXt","smallScreenImg":"asset_smallScreenImg__Q4+5P"};